import DapDSTimeGrid from './time-grid.component'

export * from './time-grid.component'
export default DapDSTimeGrid

DapDSTimeGrid.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-time-grid': DapDSTimeGrid
  }
}
